import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by"><b>BonelessGrills &copy; 2018</b></span>

  `,
})
export class FooterComponent {
}



// WEBPACK FOOTER //
// ./src/app/@theme/components/footer/footer.component.ts